import { render } from "./StudentPlaceEvaluation.vue?vue&type=template&id=31d73f65"
import script from "./StudentPlaceEvaluation.vue?vue&type=script&lang=js"
export * from "./StudentPlaceEvaluation.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__